import { UserManagerSettings } from 'oidc-client-ts';

// OIDC configuration interface matching the server response
interface OIDCConfigResponse {
    authority: string;
    client_id: string;
    redirect_uri: string;
    post_logout_redirect_uri: string;
    silent_redirect_uri: string;
    response_type: string;
    scope: string;
    load_user_info: boolean;
    automatic_silent_renew: boolean;
    monitor_session: boolean;
    metadata: {
        authorization_endpoint: string;
        token_endpoint: string;
        end_session_endpoint: string;
        userinfo_endpoint: string;
        jwks_uri: string;
    };
}

// Cache for the OIDC configuration
let cachedConfig: UserManagerSettings | null = null;

// Function to fetch OIDC configuration from the server
async function fetchOIDCConfig(): Promise<UserManagerSettings> {
    try {
        const response = await fetch('/api/oidc/config');
        if (!response.ok) {
            throw new Error(`Failed to fetch OIDC config: ${response.status}`);
        }

        const config: OIDCConfigResponse = await response.json();

        // Convert server response to UserManagerSettings format
        const userManagerSettings: UserManagerSettings = {
            authority: config.authority,
            client_id: config.client_id,
            redirect_uri: config.redirect_uri,
            post_logout_redirect_uri: config.post_logout_redirect_uri,
            silent_redirect_uri: config.silent_redirect_uri,
            response_type: config.response_type,
            scope: config.scope,
            loadUserInfo: config.load_user_info,
            automaticSilentRenew: config.automatic_silent_renew,
            monitorSession: config.monitor_session,
            metadata: {
                authorization_endpoint: config.metadata.authorization_endpoint,
                token_endpoint: config.metadata.token_endpoint,
                end_session_endpoint: config.metadata.end_session_endpoint,
                userinfo_endpoint: config.metadata.userinfo_endpoint,
                jwks_uri: config.metadata.jwks_uri,
            }
        };

        return userManagerSettings;
    } catch (error) {
        console.error('Error fetching OIDC configuration:', error);
        throw error;
    }
}

// Main function to get OIDC configuration
export async function getOidcConfig(): Promise<UserManagerSettings> {
    if (cachedConfig) {
        return cachedConfig;
    }

    cachedConfig = await fetchOIDCConfig();
    return cachedConfig;
}


